import { useEffect, useState } from 'react';
import Countdown, { zeroPad } from 'react-countdown';
import { IDS_TO_HIDE_PREDICTION } from '~/utils/constants';

import * as S from './styles';
import { Props } from './types';

export const PositionBox = ({
  prediction,
  tolerance,
  unitData,
  lineData,
}: Props) => {
  const [showToleranceTime, setShowToleranceTime] = useState(false);
  const turnHasCome = lineData.notifications.length > 0;
  const toleranceTime = new Date(
    lineData.notifications[0]?.created_at
  ).getTime();

  useEffect(() => {
    if (lineData.notifications.length > 0) {
      setShowToleranceTime(true);
    }
  }, [lineData.notifications]);

  const renderer = ({ minutes, seconds, completed }: any) => {
    if (completed) {
      return (
        <S.ContentTolerance>
          <S.ToleranceText>Tempo esgotado</S.ToleranceText>
        </S.ContentTolerance>
      );
    } else {
      return (
        <span>
          <S.ContentTolerance>
            <S.ToleranceText>
              Tempo de tolerância:{' '}
              <span>
                {zeroPad(minutes)}:{zeroPad(seconds)}
              </span>
            </S.ToleranceText>
          </S.ContentTolerance>
        </span>
      );
    }
  };

  return (
    <S.Container>
      <S.WrapperPosition cover={unitData.cover_image} turnHasCome={turnHasCome}>
        {turnHasCome ? (
          <S.ContentHasCome>
            <S.TextTurnHasCome>Sua vez chegou!</S.TextTurnHasCome>
            <S.DescriptionTurnHasCome>{`Apresente-se a hostess e aproveite o ${unitData.name}`}</S.DescriptionTurnHasCome>
          </S.ContentHasCome>
        ) : (
          <>
            <S.TextPosition>{`${lineData.position}º`}</S.TextPosition>
            <S.DescriptionPosition>
              Posição na fila de espera
              <br />
              {lineData.people} {lineData.people > 1 ? 'pessoas' : 'pessoa'}
            </S.DescriptionPosition>
          </>
        )}
      </S.WrapperPosition>
      <S.WrapperRestaurantInfo>
        <S.ContentInfo
          hasPrediction={
            !!prediction && !!prediction.maxTime && !!prediction.minTime
          }
        >
          <S.RestaurantIcon image={unitData.profile_image} />
          <S.TextInfoBox>
            <S.RestaurantTitle>{unitData.name}</S.RestaurantTitle>
            {!!lineData.code && (
              <S.SpanInfoMedium>
                Código de consumo: <b>{lineData.code}</b>
              </S.SpanInfoMedium>
            )}
          </S.TextInfoBox>
        </S.ContentInfo>
        {prediction &&
          prediction.maxTime &&
          prediction.minTime &&
          !IDS_TO_HIDE_PREDICTION.includes(unitData.id) && (
            <S.SpanInfoMedium>
              Previsão da sua vez chegar é entre:{' '}
              <b>
                {prediction.minTime} e {prediction.maxTime}
              </b>
            </S.SpanInfoMedium>
          )}
        {showToleranceTime &&
          turnHasCome &&
          (tolerance || null) !== null &&
          (toleranceTime || null) !== null && (
            <Countdown
              date={toleranceTime + tolerance! * 60000}
              renderer={renderer}
            />
          )}
      </S.WrapperRestaurantInfo>
    </S.Container>
  );
};
